require('./src/pageslide.module');
require('./src/libs/ac.pageslide.directive');
require('./src/services/ac.pageslideCommunication.service');
